import React, { useState } from "react";
import {
  Button,
  Drawer,
  Space,
  Tag,
  Typography,
  Spin,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useLicensesActions, useLicensesState } from "src/reducers/subscription";
import SubscriptionDrawerFooter from "./SubscriptionDrawerFooter";
import SubscriptionDrawerHeader from "./SubscriptionDrawerHeader";
import SubscriptionDrawerMetaRow from "./SubscriptionDrawerMetaRow";
import { currency, statusMeta } from "./subscriptionDrawerUtil";
import SubscriptionDrawerPaymentInfo from "./SubscriptionDrawerPaymentInfo";
import SubscriptionDrawerLicenseActions from "./SubscriptionDrawerLicenseActions";
import SubscriptionDrawerChildrenGroupsList from "./SubscriptionDrawerChildrenGroupsList";
import BuyLicense from "../buyLicense/BuyLicense";
import { useLanguage } from "src/providers/LanguageProvider";

const { Text } = Typography;

export default function SubscriptionDrawer() {
  const { t } = useLanguage();

  const { managementDrawerOpen, selected, loadingCancelMainLicense } = useLicensesState();
  const { load, setSelectedRow, setManagementDrawerOpen } = useLicensesActions();

  const [showBuyLicense, setShowBuyLicense] = useState(false);

  const handleOpenChildModal = () => setShowBuyLicense(true);

  const onSubmitBuyLicense = async () => {
    load(() => {
      if (selected?.Id) setSelectedRow(selected.Id);
      setShowBuyLicense(false);
    });
  };

  if (!selected) return null;

  const titleText = `${selected?.service || selected?.plan || t("SUBSCRIPTION")} • ${selected?.plan || "-"}`;
  return (
    <>
      <BuyLicense
        mainLicense={selected}
        onSubmit={onSubmitBuyLicense}
        onCancel={() => setShowBuyLicense(false)}
        open={showBuyLicense}
      />

      <Drawer
        title={titleText}
        open={managementDrawerOpen}
        onClose={() => setManagementDrawerOpen(false)}
        footer={<SubscriptionDrawerFooter />}
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={handleOpenChildModal}>
            {t("ADD_CHILD_PRODUCT")}
          </Button>
        }
        width={520}
        destroyOnClose
      >
        <Spin spinning={loadingCancelMainLicense}>
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            <SubscriptionDrawerHeader />

            <SubscriptionDrawerMetaRow label={t("AMOUNT")}>
              {currency(selected.amount)} <Text type="secondary">/ {t(selected.interval)}</Text>
            </SubscriptionDrawerMetaRow>

            <SubscriptionDrawerMetaRow label={t("STATUS")}>
              <Tag color={statusMeta[selected.status]?.color}>
                {statusMeta[selected.status]?.text}
              </Tag>
            </SubscriptionDrawerMetaRow>

            <SubscriptionDrawerMetaRow label={t("NEXT_RENEWAL")}>
              {selected.nextRenewal || "-"}
            </SubscriptionDrawerMetaRow>

            <SubscriptionDrawerMetaRow label={t("PAYMENT")}>
              <SubscriptionDrawerPaymentInfo last4={selected.cardLast4} />
            </SubscriptionDrawerMetaRow>

            <SubscriptionDrawerLicenseActions />

            {selected?.children?.length > 0 ? <SubscriptionDrawerChildrenGroupsList /> : null}
          </Space>
        </Spin>
      </Drawer>
    </>
  );
}
